import { render, staticRenderFns } from "./ForumQuote.vue?vue&type=template&id=4feb46b4&"
import script from "./ForumQuote.vue?vue&type=script&lang=js&"
export * from "./ForumQuote.vue?vue&type=script&lang=js&"
import style0 from "./ForumQuote.vue?vue&type=style&index=0&id=4feb46b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports